import { MiddlewareAPI, Dispatch, Action } from "redux";
import { Payload } from "./actions";

/**
 * Configures the dispatchActions middleware
 * @param locationChangeAction  redux action to handle when route location changes
 * @param getActionPayload  function to get the payload of the action
 */
export const configureDispatchActions = (
    locationChangeAction: string,
    getActionPayload: (action: any) => any,
    getRouteParams: (state: any) => any,
    shouldResolveParent?: (parent: any, state: any) => boolean
) => {

    const resolveAll = (routeResult: any, api: MiddlewareAPI<any>, depth = 0) => {

        if (!routeResult.ignoreParentResolve || depth === 0) {
            if (routeResult.resolve instanceof Array) {
                routeResult.resolve.forEach((resolve: any) => dispatchIfFunction(resolve, api));
            } else {
                dispatchIfFunction(routeResult.resolve, api);
            }
        }

        if (routeResult.parent) {
            if (shouldResolveParent === undefined || shouldResolveParent(routeResult.parent, api.getState())) {
                resolveAll(routeResult.parent, api, depth + 1);
            }
        }
    };

    const dispatchIfFunction = (resolve: any, api: MiddlewareAPI<any>) => {
        if (typeof resolve === "function") {
            const action = resolve(getRouteParams(api.getState()));
            api.dispatch(action);
        }
    };

    // main middleware function
    return (api: MiddlewareAPI<any>) => (next: Dispatch<Action<any>>) => (action: Action & Payload<Location>) => {
        const result = next(action);

        if (action.type === locationChangeAction) {
            const routeResult = getActionPayload(action);

            if (routeResult) {
                resolveAll(routeResult, api);
            }
        }

        return result;
    };
};
